const INCENTIVE_SUMMARY = {
  errorMessage:
    'Houve um erro ao carregar o resumo de incentivos. Tente novamente mais tarde.',
  achievedTargetLabel: 'Meta atingida',
  notAchievedTargetLabel: 'Não atingiu a meta',
  downloadButtonTextSuffix: 'incentivos',
  deliveryTime: {
    label: 'Entrega em 35 minutos',
    description:
      'Incentivo pago por manter o tempo médio de entrega dentro da meta.',
  },
  releaseTime: {
    label: 'Tempo Médio de Liberação',
    description:
      'Incentivo pago quando o tempo de liberação dos seus pedidos está dentro da meta.',
  },
  idealPortfolio: {
    label: 'Portfólio Ideal',
    description:
      'Incentivo pago quando a meta de produtos do portfólio ideal é atingida',
  },
  availability: {
    label: 'Disponibilidade',
    description:
      'Incentivo pago quando sua loja atinge a meta por se manter aberta conforme o horário de funcionamento cadastrado.',
  },
  fillRate: {
    label: 'Taxa de Aceitação',
    description:
      'Incentivo pago ou deduzido quando você aceita ou não os pedidos na sua loja.',
  },
}

export default INCENTIVE_SUMMARY
